<div class="d-flex w-full h-full">
  <mat-card class="m-auto" style="max-width: 380px;">
    <mat-card-header class="m-b-24">
      <mat-card-title-group>
        <mat-card-title>Авторизация</mat-card-title>
        <img  routerLink="/catalog" style="border-radius:80px;max-width: 80px;max-height: 80px" src="assets/images/pro_mobile_service.jpg">
      </mat-card-title-group>

    </mat-card-header>

    <mat-card-content>
      <form class="form-field-full" [formGroup]="loginForm">
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput placeholder="email" formControlName="email" required type="email">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Пароль</mat-label>
          <input matInput placeholder="Пароль" type="password"
                 formControlName="password" required>
        </mat-form-field>


        <button class="w-full m-y-16" mat-raised-button color="primary"
                [disabled]="loginForm.invalid" [loading]="isSubmitting"
                (click)="login()">Войти
        </button>

        <div>У вас нет аккаунта?
          <a routerLink="/auth/register">Зарегистрироваться</a>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
